import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";

interface rentInstanceBlob {
  gpu_count: number;
  host_id: number;
  service_name: string;
  template_id: number;
  user_id: number;
}

interface stopRentalBlob {
  instance_id: number;
  host_id: number;
}

interface InstancePublicKeyBlob {
  instance_id: number;
  public_key: string;
}

export const getInstances = () => {
  const url = `instances`;
  return axiosClient.get<ResultDataModel<any>>(url);
};


export const getInstanceDetail = (instance_id: string) => {
  const url = `instances/${instance_id}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

export const startInstanceRent = (rentInstanceBlob: rentInstanceBlob) => {
  const url = `instances`;
  let body = rentInstanceBlob;
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const stopInstanceRent = (instance_id: string, host_id: string) => {
  const url = `instances/${instance_id}?hostId=${host_id}`;
  return axiosClient.delete<ResultDataModel<any>>(url);
};

export const getInstanceSSHCommand = (user_id: number, instance_id: number) => {
  const url = `instances/${instance_id}/sshCommand`;
  const headers = {
    headers: {
      user_id,
    },
  };
  return axiosClient.get<ResultDataModel<any>>(url, headers);
};

export const updateInstancePublicKey = (
  user_id: number,
  InstancePublicKeyBlob: InstancePublicKeyBlob
) => {
  const { instance_id, public_key } = InstancePublicKeyBlob;
  const url = `instances/${instance_id}/sshKey`;
  const headers = {
    headers: {
      user_id,
    },
  };
  const data = {
    public_key: public_key,
  };
  return axiosClient.put<ResultDataModel<any>>(url, data, headers);
};
